module.exports = __webpack_public_path__ + "static/media/FRAME.ab388508.png";